import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateGuarantees } from "@/redux/reducers/guarantees_v2";

const getNewGuarantees = sharedService.injectEndpoints({
  endpoints: builder => ({
    getNewGuarantees: builder.query({
      query: () => "parameters/guarantees",
      transformResponse: response => response.items,
      providesTags: ["NewGuarantees"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateGuarantees(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetNewGuaranteesQuery } = getNewGuarantees;

